
const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            How does it work?
          </h2>
          <p className="text-xl text-gray-600">
            You can use this as it is or tweak it as you seem necessary.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Left Column */}
          <div className="flex flex-col items-center text-center">
            <div className="mb-6 w-full h-[200px] flex items-center justify-center">
              <img
                src="https://dynamico.cloud/assets/img/powerful_form.png"
                alt="Build Your Form"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              1. Build Your Form
            </h3>
            <p className="text-gray-600 min-h-[100px]">
              Build your own custom inspection, checklist and audit forms using our powerful forms builder. Embed your own safety and compliance rules for realtime validation
            </p>
          </div>

          {/* Middle Column */}
          <div className="flex flex-col items-center text-center">
            <div className="mb-6 w-full h-[200px] flex items-center justify-center">
              <img
                src="https://dynamico.cloud/assets/img/data_collection.png"
                alt="Submit Your Inspection"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              2. Submit Your Inspection
            </h3>
            <p className="text-gray-600 min-h-[100px]">
              Collect rich data sets using our intuitive mobile applications that work seamlessly on iPhone, iPad and Android devices.
            </p>
          </div>

          {/* Right Column */}
          <div className="flex flex-col items-center text-center">
            <div className="mb-6 w-full h-[200px] flex items-center justify-center">
              <img
                src="https://dynamico.cloud/assets/img/PaperForm-To-Computer-03.png"
                alt="Distribute Reports"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              3. Distribute Reports and Analyze Your Data
            </h3>
            <p className="text-gray-600 min-h-[100px]">
              Distribute your data / reports and automatically dispatch pre-populated forms for maintenance and work-orders.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
